import { cn } from '@/lib/utils';
import React from 'react';

import { useDynamicLocale } from '@/hoslog-intl';
import { useFieldState } from '.';

const FormMessage = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, children, ...props }, ref) => {
    const { t } = useDynamicLocale();
    const { error, formMessageId } = useFieldState();

    const raw = error ? String(error.message ?? '') : typeof children === 'string' ? children : '';

    if (!raw) return null;

    const isKey = raw.startsWith('common.') || raw.startsWith('storeManagement.') || raw.startsWith('validation.');
    const text = isKey ? t(raw) : raw;

    return (
      <p ref={ref} id={formMessageId} className={cn('text-sm font-medium text-destructive-text', className)} {...props}>
        {text}
      </p>
    );
  },
);

FormMessage.displayName = 'FormMessage';

export { FormMessage };
